import React from 'react';
import { PRODUCT_FACTS } from '../../lib/marketing';

// Verifiable product facts only (no customer/usage statistics).
export const TrustStats = ({ facts = PRODUCT_FACTS }) => (
  <dl className="grid grid-cols-2 divide-border overflow-hidden rounded-2xl border border-border bg-white sm:grid-cols-4 sm:divide-x" data-testid="product-facts">
    {facts.map((f) => (
      <div key={f.label} className="flex flex-col-reverse px-6 py-6 sm:py-7">
        <dt className="mt-1 text-sm text-muted-foreground">{f.label}</dt>
        <dd className="text-3xl font-bold tracking-tight text-primary sm:text-4xl">{f.value}</dd>
      </div>
    ))}
  </dl>
);
